import api from '@/services/api';

export const getRoles = async (restricted = false) => {
  const result = await api.get(`/roles/${restricted}`);
  return result.data;
};
